<div class="snack-flex-container">
  <div class="snack-message">{{ data.message }}</div>
  <button mat-button class="snack-action" (click)="actionDismissThis()">{{ data.action }}</button>
</div>
